import { clearAllCache } from './functions';
import { swalDelete, swalDeleteConfirm, swalErro } from './swal';
import httpClient, { isHttpError } from '../services/httpClient';

export async function handleDelete(
  id: string | number,
  pathApi: string, // exemplo: "cores"
  pathRedirect?: string, // exemplo: "daf/adm/cores"
  clearCache?: () => void,
  cacheKey?: string,
  showSwalDelete = true,
  idRegistro?: string | number,
  fetchData?: (id: string | number) => void,
  messageDeleteConfirm = {
    title: 'Registro Deletado!',
    html: '<span style="font-size: 1.45rem;">Registro <b>deletado</b> com sucesso!</span>',
  },
) {
  try {
    // 1. Confirmação
    if (showSwalDelete) {
      const result = await swalDelete();
      if (!result) return false;
    }

    // 2. Exclusão
    await httpClient.delete(`/api/${pathApi}/${id}`);

    // 3. Sucesso
    swalDeleteConfirm(messageDeleteConfirm);

    // LIMPAR CACHE
    if (clearCache) {
      clearCache();
    }
    if (cacheKey) {
      clearAllCache(cacheKey);
    }

    // 4. Redirecionar (opcional)
    if (pathRedirect) {
      window.location.href = `#/${pathRedirect}`;
    }

    // 5. Recarregar dados (opcional)
    if (fetchData) {
      //!isCreate &&
      fetchData(idRegistro ?? id);
    }
    return true;
  } catch (error: any) {
    if (isHttpError(error)) {
      swalErro(error.response?.data.message);
    }
    console.error('Erro ao excluir registro', error);
    swalErro('Não foi possível excluir o registro. Tente novamente.');
  }
}
